import styled from '@emotion/styled';
import { Variables } from '../base/variables/variables';

export const TabContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: auto;
`;

export const TabList = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 0px;
    background: ${Variables.Swatches.Gray3};
    border-radius: 4px 4px 0px 0px;
    height: 32px;
    width: 100%;
`;

interface ITabProps {
    active: boolean;
    zIndex: number;
}

export const Tab = styled.button<ITabProps>`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 6px 12px;
    gap: 6px;
    height: 100%;
    min-width: fit-content;
    background: ${props => props.active ? Variables.Swatches.Gray1 : 'transparent'};
    border-radius: 4px 4px 0px 0px;
    border: none;
    cursor: pointer;
    outline: none;
    user-select: none;
    z-index: ${props => props.zIndex};
    flex-shrink: 0;
    transition: background 0.15s ease;

    &:hover {
        background: ${props => props.active ? Variables.Swatches.Gray1 : Variables.Swatches.AlphaLightGray30};
    }

    &:focus-visible {
        outline: 2px solid ${Variables.Colors.b300};
        outline-offset: -2px;
    }
`;

export const TabIcon = styled.span<{ active: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    flex-shrink: 0;

    svg {
        width: 16px;
        height: 16px;
        fill: ${props => props.active ? Variables.Swatches.Gray8 : Variables.Swatches.Gray7};
    }
`;

export const TabLabel = styled.span<{ active: boolean }>`
    font-family: 'Calibre', ${Variables.Fonts.calibre};
    font-style: normal;
    font-weight: ${props => props.active ? '500' : '400'};
    font-size: 13px;
    line-height: 16px;
    color: ${props => props.active ? Variables.Swatches.Gray9 : Variables.Swatches.Gray8};
    white-space: nowrap;
    flex-shrink: 0;
`;

export const TabDivider = styled.div`
    width: 2px;
    height: 30%;
    background-color: ${Variables.ThemeLight.BorderB1};
    flex-shrink: 0;
`;

export const TabContent = styled.div`
    display: none;
`;

